import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

const listStyle = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const NavList = ({ children, className, ...childProps }) => (
  <ul className={cx(listStyle, className)} {...childProps}>
    {children}
  </ul>
);

NavList.defaultProps = {
  role: 'navigation',
  className: '',
};

NavList.propTypes = {
  children: PropTypes.node.isRequired,
  role: PropTypes.string,
  className: PropTypes.string,
};

export default NavList;
